<template>
  <div class="con" v-loading="loading">
  <div class="text item">
    <div class="Table-Con">
      <el-form ref="ruleForm" label-width="200px" class="demo-ruleForm">
        <el-form-item :label="`${$t('lang.ConfigSetting.ModeUrl')}：`" prop="name">
          <el-select :placeholder="$t('lang.ConfigSetting.pleaseChoose')" v-model="data.mode" size="mini" class="Form-Input-Width">
            <el-option
              v-for="item in BlacKWhiteList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`${$t('lang.ConfigSetting.Domain')}：`" prop="name" v-if="data.mode=='ACCEPT'">
          <arraddinput :List="data.domain" @GetArrList="GetArrList"></arraddinput>
        </el-form-item>
        <el-form-item :label="`${$t('lang.ConfigSetting.Domain')}：`" prop="name" class="demo-ruleForm" v-if="data.mode=='REJECT'">
          <arraddinput :List="data.domain" @GetArrList="GetArrList"></arraddinput>
        </el-form-item>
      </el-form>
    </div>
  </div>
  <el-button type="danger" size="mini" @click="updateConfig" class="Config-Buttom">
    {{$t('lang.ConfigSetting.SaveApply')}}
  </el-button>
  </div>
</template>
<script>
import arraddinput from '../../../ArrAddInput/index'
import { updateConfig, listConfig } from '@/api/configurationlist'
import { progressControl } from '@/api/particulars'
import { cloneDeep, isEqual } from 'lodash'
export default {
  props:["deviceDid", "deviceSn"],
  data(){
    return{
      BlacKWhiteList:[
        {value:'',label:this.$t('lang.ConfigSetting.Disables')},
        {value:'ACCEPT',label:this.$t('lang.ConfigSetting.black')},
        {value:'REJECT',label:this.$t('lang.ConfigSetting.while')}
      ],
      BlacKWhiteValue:'',
      loading:true,
      WatchData:{
        domain: [],
        mode: ''
      },
      data: {}
    }
  },
  watch: {
    deviceSn: {
      immediate: true,
      handler: function() {
        this.getConfig()
      }
    }
  },
  components:{
    arraddinput
  },
  methods:{
    // 获取配置参数
    getConfig() {
      this.loading = true
      listConfig(this.deviceSn, this.deviceDid, [
        {
          section: "domain",
          config: "filter",
          options: [{ option: "mode" }],
          lists: [{ list: "domain" }]
        }
      ]).then(res => {
        const data = res.data.data.mess[0];
        this.$set(this.data, "mode", data.s_objects[0].options.mode);
        this.$set(
          this.data,
          "domain",
          data.s_objects[0].lists.domain
        );
        this.WatchData = cloneDeep(this.data)
        this.loading = false
      }).catch(err => {
        this.$message({
          message: this.$t('lang.request.timeout'),
          type: "warning"
        });
      });
    },
    updateConfig(){
      if(!isEqual(this.WatchData, this.data)) {
        let data={}
        for(let key in this.data){
          data[key]=this.data[key]
        }
        updateConfig(this.deviceSn,this.deviceDid,[
          { section:"domain",
            config: "filter",
            action:0,
            index:[0],
            server:'filter',
            options:{
              mode:data.mode
            },
            lists:{
              domain:data.domain
            }
          }
        ]).then((res)=>{
          if(res.data.data.mess===0){
            //重启防火墙
            updateConfig(this.deviceSn,this.deviceDid,[
              { section:"domain",
                config: "filter",
                action:0,
                index:[0],
                server:'firewall',
                options:{
                  mode:data.mode
                },
                lists:{
                  domain:data.domain
                }
              }
            ]).then((res) => {
                this.$message({
                    showClose: true,
                    message: this.$t('lang.ConfigSetting.Successfulconfiguration'),
                    type: 'success'
                })
                this.getConfig()
            })  
          }else {
            this.$message({
              showClose: true,
              message: this.$t('lang.ConfigSetting.Configurationerror'),
              type: 'warning'
            });
            return
          }
        })
      }else{
        this.$message({
          showClose: true,
          message: this.$t('lang.ConfigSetting.Nochangesmade'),
          type: 'warning'
        });
        return
      } 
    },
    //输入框组件回调
    GetArrList(props){
      this.data.domain=props
    }
  },
}
</script>
<style src='../../../common.css' scoped></style>

